import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { queryClient } from "../../services/queryClient";
import { getToken } from "../../utils/getToken";

type Product = {
  name: string;
  address: string;
  lga: string;
  state: string;
  countryCode: string;
  phoneNumber: string;
};

export const useUpdateBranchMutation = (id: string) => {
  const token = getToken();

  return useMutation({
    mutationFn: (data: Product) => {
      return axiosInstance.patch(`/branches/${id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    },
    onSuccess: async (data: any) => {
      message.success(data?.data?.message);
      queryClient.invalidateQueries({ queryKey: ["getBranches"] });
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message || "Error updating branch");
    },
  });
};
